module.exports = __webpack_public_path__ + "img/bg005.7218ed9a.svg";